<!-- 显示大图 -->
<template>
    <div class="show-big-img" v-show="show">
        <img :src="src">
        <i class="el-icon-close close-icon" @click="hide"></i>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        props:{
            src:String,
            show:Boolean
        },
        data(){
            return {

            }
        },
        mounted(){

        },
        watch:{

        },
        methods:{
            hide(){
                this.$emit('hide')
            }
        }
    }
</script>
<style lang="less" scoped>
    .close-icon {
        position: absolute;
        top: 20px;
        right: 20px;
        color: white;
        font-size: 56px;
        cursor:pointer;
    }
    .show-big-img {
        position: fixed;
        left: 0;
        top:0;
        width: 100%;
        height: 100%;
        z-index: 999;
        background:rgba(0,0,0,0.6);
        img {
            max-height: 90%;
            max-width: 90%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
</style>
